import { EUserRole, SERVICE_TYPE_ERROR_CODE, StatusEnum } from "../../../constants";
export var JcKey = {
    JcPaging: "jcPaging",
    JcServiceType: "jcServiceType",
    Status: "Status",
    VehicleList: "VehicleList",
    ServiceAdvisorList: "ServiceAdviceListApi",
    CancellationReasonList: "CancellationReasonList",
    CancelJobCard: "cancelJobCardurl",
    ServiceAdvisorUpdate: "ServiceAdvisorUpdateUrl",
    BranchList: "branchList"
};
export var JCMenuFeatures = /*#__PURE__*/ function (JCMenuFeatures) {
    JCMenuFeatures["ViewSpareIssue"] = "ViewSpareIssueJobCard";
    JCMenuFeatures["ReassignServiceAdvisor"] = "ReassignServiceAdvisorJobCard";
    JCMenuFeatures["ReassignFinalInspector"] = "ReassignFinalInspectorJobCard";
    JCMenuFeatures["ChangeServiceType"] = "ChangeServiceTypeJobCard";
    JCMenuFeatures["Cancel"] = "CancelJobCard";
    JCMenuFeatures["AssignFinalInspector"] = "AssignFinalInspectorJobCard";
    JCMenuFeatures["ViewServiceEstimate"] = "ViewServiceEstimateJobCard";
    JCMenuFeatures["ViewTaskSummary"] = "ViewTaskSummaryJobCard";
    JCMenuFeatures["CreateNewSpareIssue"] = "CreateNewSpareIssueJobCard";
    return JCMenuFeatures;
}({});
export var FIMenuFeatures = /*#__PURE__*/ function (FIMenuFeatures) {
    FIMenuFeatures["ReassignFinalInspector"] = "ReassignFinalInspector";
    FIMenuFeatures["ViewServiceEstimate"] = "ViewServiceEstimate";
    FIMenuFeatures["ViewTaskSummary"] = "ViewTaskSummary";
    return FIMenuFeatures;
}({});
export var getFeaturesByStatusAndRbac = function (row, rbacControl, serviceTypes, features, role) {
    var _menusList;
    if (role === EUserRole.FinalInspector) {
        return features === null || features === void 0 ? void 0 : features.filter(function (feature) {
            var _rbacControl$feature$;
            return Boolean(rbacControl === null || rbacControl === void 0 || (_rbacControl$feature$ = rbacControl[feature.Name]) === null || _rbacControl$feature$ === void 0 ? void 0 : _rbacControl$feature$.showInMoreMenu);
        });
    }
    var dynamicValues = (serviceTypes === null || serviceTypes === void 0 ? void 0 : serviceTypes.DynamicValues) || [];
    var changeServiceTypeMenu = features === null || features === void 0 ? void 0 : features.find(function (element) { return element.Name === JCMenuFeatures.ChangeServiceType; });
    var hasMatchingServiceType = dynamicValues === null || dynamicValues === void 0 ? void 0 : dynamicValues.some(function (item) { return (item === null || item === void 0 ? void 0 : item.FromServiceTypeId) === (row === null || row === void 0 ? void 0 : row.RepairTypeId); });
    var statusesWithChangeServiceType = [StatusEnum.ReadyForWork, StatusEnum.WorkStarted, StatusEnum.WorkCompleted, StatusEnum.FinalInspection, StatusEnum.Rework, StatusEnum.InspectionCompleted];
    var menusList = features !== null && features !== void 0 ? features : [];
    switch (row.Key) {
        case StatusEnum.ReadyForWork:
        case StatusEnum.AwaitingForParts:
        case StatusEnum.InitiateWork:
        case StatusEnum.WorkStarted:
        case StatusEnum.InspectionCompleted:
            menusList = features === null || features === void 0 ? void 0 : features.filter(function (element) { return element.Name !== JCMenuFeatures.AssignFinalInspector && element.Name !== JCMenuFeatures.ReassignFinalInspector && element.Name !== JCMenuFeatures.ViewSpareIssue && element.Name !== JCMenuFeatures.ChangeServiceType; });
            if (statusesWithChangeServiceType !== null && statusesWithChangeServiceType !== void 0 && statusesWithChangeServiceType.includes(row.Key)) {
                if (changeServiceTypeMenu && hasMatchingServiceType) {
                    menusList.push(changeServiceTypeMenu);
                }
            }
            break;
        case StatusEnum.Error:
            menusList = features === null || features === void 0 ? void 0 : features.filter(function (element) {
                var _row$SourceMessage;
                if (((row === null || row === void 0 || (_row$SourceMessage = row.SourceMessage) === null || _row$SourceMessage === void 0 ? void 0 : _row$SourceMessage.ErrorCode) || (row === null || row === void 0 ? void 0 : row.ErrorCode)) === SERVICE_TYPE_ERROR_CODE) {
                    return element.Name !== JCMenuFeatures.AssignFinalInspector && element.Name !== JCMenuFeatures.ReassignFinalInspector && element.Name !== JCMenuFeatures.ReassignServiceAdvisor && element.Name !== JCMenuFeatures.ViewSpareIssue;
                }
                return element.Name !== JCMenuFeatures.AssignFinalInspector && element.Name !== JCMenuFeatures.ReassignFinalInspector && element.Name !== JCMenuFeatures.ReassignServiceAdvisor && element.Name !== JCMenuFeatures.ChangeServiceType && element.Name !== JCMenuFeatures.ViewSpareIssue;
            });
            if (statusesWithChangeServiceType !== null && statusesWithChangeServiceType !== void 0 && statusesWithChangeServiceType.includes(row === null || row === void 0 ? void 0 : row.Key)) {
                if (changeServiceTypeMenu && hasMatchingServiceType) {
                    menusList.push(changeServiceTypeMenu);
                }
            }
            break;
        case StatusEnum.ReadyForInvoice:
            menusList = features === null || features === void 0 ? void 0 : features.filter(function (element) { return element.Name !== JCMenuFeatures.AssignFinalInspector && element.Name !== JCMenuFeatures.ReassignFinalInspector && element.Name !== JCMenuFeatures.CreateNewSpareIssue && element.Name !== JCMenuFeatures.ChangeServiceType; });
            break;
        case StatusEnum.WorkCompleted:
            menusList = features === null || features === void 0 ? void 0 : features.filter(function (element) { return element.Name !== JCMenuFeatures.ReassignFinalInspector && element.Name !== JCMenuFeatures.ViewSpareIssue && element.Name !== JCMenuFeatures.ChangeServiceType; });
            if (changeServiceTypeMenu && hasMatchingServiceType) {
                menusList.push(changeServiceTypeMenu);
            }
            break;
        case StatusEnum.FinalInspection:
        case StatusEnum.Rework:
            menusList = features === null || features === void 0 ? void 0 : features.filter(function (element) { return element.Name !== JCMenuFeatures.AssignFinalInspector && element.Name !== JCMenuFeatures.ViewSpareIssue && element.Name !== JCMenuFeatures.ChangeServiceType; });
            if (changeServiceTypeMenu && hasMatchingServiceType) {
                menusList.push(changeServiceTypeMenu);
            }
            break;
        case StatusEnum.Invoiced:
        case StatusEnum.Delivered:
        case StatusEnum.Cancelled:
            menusList = features === null || features === void 0 ? void 0 : features.filter(function (element) { return element.Name !== JCMenuFeatures.AssignFinalInspector && element.Name !== JCMenuFeatures.ReassignFinalInspector && element.Name !== JCMenuFeatures.ReassignServiceAdvisor && element.Name !== JCMenuFeatures.CreateNewSpareIssue && element.Name !== JCMenuFeatures.ChangeServiceType; });
            break;
        default:
            break;
    }
    return (_menusList = menusList) === null || _menusList === void 0 ? void 0 : _menusList.filter(function (feature) {
        var _rbacControl$feature$2;
        return Boolean(rbacControl === null || rbacControl === void 0 || (_rbacControl$feature$2 = rbacControl[feature.Name]) === null || _rbacControl$feature$2 === void 0 ? void 0 : _rbacControl$feature$2.showInMoreMenu);
    });
};
export var ListViewTypes = {
    List: 'List',
    Card: 'Card'
};
